import { Sun, CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./About.css";

function About() {
  const navigate = useNavigate();

  const services = [
    {
      title: "Residential Solar",
      description: "Smart rooftop solar systems designed to reduce electricity bills while increasing energy independence for homeowners."
    },
    {
      title: "Commercial & Industrial",
      description: "High-capacity solar installations that help businesses lower operational costs and meet sustainability goals."
    },
    {
      title: "Design & Engineering",
      description: "Precision-driven solar design based on site analysis, energy demand, and future scalability."
    },
    {
      title: "Turnkey Execution",
      description: "Complete project management from consultation and installation to commissioning and maintenance."
    }
  ];

  const whyChooseUs = [
    "Experienced solar professionals and certified engineers",
    "Use of high-quality, tested solar components",
    "Customized solutions for every client",
    "Strong focus on safety and compliance",
    "Reliable after-sales service and support"
  ];

  return (
    <>
      {/* Main About Section */}
      <section className="about-section">
        <div className="about-icon">
          <Sun size={48} />
        </div>
        <h2 className="about-title">About Solar</h2>
        <p className="about-text">
          Solar is committed to accelerating the transition to renewable energy 
          through innovation, sustainability, and smart solar solutions for homes 
          and businesses.
        </p>
      </section>

      {/* Who We Are Section */}
      <section className="who-we-are-section">
        <div className="content-wrapper">
          <div className="two-col-grid">
            <div className="text-content">
              <h2>Who We Are</h2>
              <p>
                Solar is a rapidly growing solar energy company committed to transforming how energy is produced and consumed. We specialize in designing, engineering, and deploying advanced solar power systems that are efficient, durable, and economically viable.
              </p>
              <p>
                Our expertise spans residential rooftops, commercial facilities, and large-scale industrial installations. With a strong focus on quality and performance, we ensure every project delivers maximum energy output and long-term reliability.
              </p>
            </div>
            <div className="image-content">
              <img src="https://images.pexels.com/photos/4254167/pexels-photo-4254167.jpeg" alt="Who We Are" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-vision-section">
        <div className="content-wrapper">
          <div className="two-col-grid">
            <div className="info-card">
              <h3>Our Mission</h3>
              <p>
                To provide innovative, affordable, and high-performance solar solutions that empower individuals and organizations to reduce energy costs and environmental impact.
              </p>
            </div>
            <div className="info-card">
              <h3>Our Vision</h3>
              <p>
                To become a trusted leader in renewable energy by accelerating solar adoption and contributing to a sustainable and energy-secure future.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do Section */}
      <section className="what-we-do-section">
        <div className="content-wrapper">
          <h2 className="section-heading">What We Do</h2>
          <div className="four-col-grid">
            {services.map((service, index) => (
              <div key={index} className="service-box">
                <h4>{service.title}</h4>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="content-wrapper">
          <div className="two-col-grid reverse">
            <div className="text-content">
              <h2>Why Choose Us</h2>
              <ul className="check-list">
                {whyChooseUs.map((item, index) => (
                  <li key={index}>
                    <CheckCircle size={20} className="check-icon" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="image-content">
              <img src="https://images.pexels.com/photos/9875441/pexels-photo-9875441.jpeg" alt="Why Choose Us" />
            </div>
          </div>
        </div>
      </section>

      {/* Sustainability Section */}
      <section className="sustainability-section">
        <div className="content-wrapper">
          <div className="two-col-grid">
           
            <div className="text-content">
              <h2>Commitment to Sustainability</h2>
              <p>
                Sustainability drives every decision we make. Each solar system we install helps reduce carbon emissions, conserve natural resources, and promote responsible energy consumption.
              </p>
              <p>
                Choosing Solar means partnering with a company that values environmental responsibility as much as technical excellence.
              </p>
            </div>
             <div className="image-content">
              <img src="https://images.pexels.com/photos/4254167/pexels-photo-4254167.jpeg" alt="Sustainability" />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="content-wrapper">
          <h2>Start Your Solar Journey Today</h2>
          <p>Let us help you transition to clean, reliable, and cost-effective solar energy.</p>
          <button className="cta-btn" onClick={() => navigate("/contact")}>Contact Us</button>
        </div>
      </section>
    </>
  );
}

export default About;
